import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const Calls = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Calls'))
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Dispositions',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_CALLS}/${RoutePaths.ADMIN_SETTINGS_CALLS_DISPOSITIONS}`,
          },
          {
            label: 'Purposes',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_CALLS}/${RoutePaths.ADMIN_SETTINGS_CALLS_PURPOSES}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
